<template>
	<div>
		<navigator :index="2"></navigator>
		<div class="localhost">
			<div class="localhostText">首页/<span style="color:#333;">筑橙新闻</span>
			</div>
		</div>
		<div class="zaneconNewsText">筑橙新闻</div>
		<div class="newsItemBox">
			<router-link :to="{name:'news',query:{id:item.id,isPerview:false,currentIndex:index}}" class="newsItem" v-for="(item,index) in list" :key="index">
				<div class="newsLeft">
					<img v-if="!item.img" style="width:100%;height:100%;display:block;"
						src="../resource/images/newsDefault.jpg" alt="筑橙新闻">
					<img v-if="item.img" style="width:100%;height:auto;display:block;" :src="url+item.img" alt="筑橙新闻">
				</div>
				<div class="newsRight">
					<div class="newsTitle">{{item.titleText}}</div>
					<div class="newsDate">{{item.createTime}}</div>
					<div class="newsContent">{{item.contentText}}
					</div>
					<div class="newsMore">了解更多 >
					</div>
				</div>
			</router-link>
		</div>

		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	import url from "../url.js"
	import axios from 'axios'
	import QRCode from "qrcodejs2"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'newsList',
		data() {
			return {
				url: url.develop,
				id: "", //根据当前id去预览数据
				currentIndex: 0,
				list: [], //新闻列表
			}
		},
		mounted() {

			this.getList()
		},
		methods: {
			async getList() {
				await axios.get(`${url.develop}/website/mobile/journalismFindPage`, {
					params: {
						pageNum: 1,
						pageSize: 999999
					}
				}).then(res => {
					console.log("res:", res)
					if (res.data.code) {

						let regex = /(<([^>]+)>)/ig //去除html标签

						for (let i = 0; i < res.data.data.content.length; i++) {
							res.data.data.content[i].titleText = res.data.data.content[i].title.replace(regex,
								"");
							res.data.data.content[i].contentText = res.data.data.content[i].content.replace(
								regex,
								"").replace(/&nbsp;/ig, "")

						}

						this.list = res.data.data.content

						console.log("list:", this.list)

					}
				})
			},
		}
	}
</script>

<style scoped>
	.newsItemBox {
		min-height: calc(100vh - 65px - 85px - 156px - 279px - 86px - 50px);
	}

	.newsRight {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.newsMore {
		margin-top: 20px;
		width: 124px;
		line-height: 42px;
		border: 1px solid #ea5b24;
		border-radius: 6px;
		font-size: 14px;
		color: #ea5b24;
		text-align: center;
	}

	.newsContent {
		margin-top: 14px;
		line-height: 28px;
		font-size: 20px;
		font-weight: 400;
		text-align: left;
		color: #666;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.newsDate {
		line-height: 22px;
		font-size: 16px;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		margin-top: 6px;
	}

	.newsTitle {
		line-height: 42px;
		font-size: 30px;
		font-weight: 400;
		text-align: left;
		color: #333;
	}

	.newsItem {
		display: flex;
		width: 1040px;
		margin: 50px auto 0;
	}

	.newsItem:nth-last-child(1) {
		margin-bottom: 100px;
	}

	.newsLeft {
		width: 335px;
		height: 202px;
		margin-right: 30px;
		background-color: #eee;
		flex: 0 0 auto;
		overflow: hidden;
	}

	.zaneconNewsText {
		width: 1040px;
		margin: 70px auto 0;
		padding-bottom: 30px;
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
		line-height: 56px;
		font-size: 40px;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
</style>



// WEBPACK FOOTER //
// src/pages/newsList.vue